import { WAS_BACK_END_API_URL } from '../../constants';
import useSWR, { KeyedMutator } from 'swr';
import { fetchAuthenticated } from '..';
import { decryptObject } from '../../components/Encryption/obfuscationHandler';
import { TreatmentInfo, TreatmentPlansAjaxResult } from '../../shared/types/types';

export interface UseTreatmentPlanListProps {
  patientId?: string;
  token: string | null;
}

export interface UseTreatmentPlanListResponse {
  treatmentPlanListData?: TreatmentInfo[];
  treatmentPlanListDataError: any;
  treatmentPlanListDataIsLoading: boolean;
  treatmentListMutate: KeyedMutator<any[]> | null;
}

export const useTreatmentPlanList = ({ patientId, token }: UseTreatmentPlanListProps): UseTreatmentPlanListResponse => {
  const url = `${WAS_BACK_END_API_URL}/w1/patients/${patientId}/treatment-plans-dicom-doc`; //REVISIT THE T1 vs W1 part of this request

  const fetchWithToken = async (url: string, token: string | undefined) => {
    if (!token) return [];
    let data: TreatmentInfo[] = [];
    const response = await fetchAuthenticated<TreatmentPlansAjaxResult>(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token ?? 'NONE'}`,
      },
    });
    if (response?.ok) {
      if (response.parsedBody?.result?.treatablePlanData) {
        const decryptedObject = await decryptObject(response.parsedBody.result, token, null);
        data = [...decryptedObject?.treatablePlanData];
      }
    }
    return data;
  };

  const { data, error, isLoading, mutate } = useSWR([url, token], ([url, token]) => fetchWithToken(url, token ?? ''), { shouldRetryOnError: false });

  return {
    treatmentPlanListData: data,
    treatmentPlanListDataError: error,
    treatmentPlanListDataIsLoading: isLoading,
    treatmentListMutate: mutate,
  };
};
